import { render, staticRenderFns } from "./FormCheck.vue?vue&type=template&id=cb31be70&scoped=true&lang=pug"
import script from "./FormCheck.vue?vue&type=script&lang=ts"
export * from "./FormCheck.vue?vue&type=script&lang=ts"
import style0 from "./FormCheck.vue?vue&type=style&index=0&id=cb31be70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb31be70",
  null
  
)

export default component.exports